import styled from 'styled-components';

import { getThemeColor, getThemePath } from '@utils/styled';

import Typography from '@common/components/Typography';

export const OrderTotalWrapper = styled.section`
  border-radius: ${getThemePath(['borderRadiuses', 'normal.2'])}rem;
  ${({ theme }) => theme.getFluidSpacing('padding', 'scale', 3)};
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 2)}
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 2)}
  background-color: ${getThemeColor('bluegrey.95')};
  text-align: center;
`;

export const OrderTotalBeforeDiscount = styled(Typography).attrs({
  variant: 'body2',
})`
  color: ${getThemeColor('bluegrey.60')};
  text-decoration: line-through;
`;

export const OrderTotalTitle = styled(Typography).attrs({
  variant: 'paragraph1',
})`
  margin: 0;
  font-weight: 700;
`;

export const OrderTotalDeliveryNote = styled(Typography).attrs({
  variant: 'body2',
})`
  margin: 0;
  color: ${getThemeColor('bluegrey.70')};
`;
